import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useClinic() {
  const navigate = useNavigate();

  const [clinic, setClinic] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchClinic = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/clinic', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setClinic(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchClinic();
  }, [fetchClinic]);

  return { clinic, isLoading, error, refetch: fetchClinic };
}
